































/** @format */

import { Vue, Component, Mixins, Watch } from 'vue-property-decorator';
import TableMixin from '@/common/mixins/table';
import TableWidthMixin from '@/common/mixins/table-width';
import GoBackWithCloseTabMixin from '@/common/mixins/go-back-with-close-tab';
import moment from 'moment';
import { CHANNEL_LIST } from '../router-names';
// import { debounce } from 'lodash'
import * as _ from 'lodash';
import Utils from '@/utils/common';
// axios请求
import { detailChannelList } from '@/api/parking-lot-management/index';

@Component
// @Component
export default class ChannelListDetail extends Mixins(GoBackWithCloseTabMixin) {
  channelList = {};
  channelId = '';
  headTitle = '通道详情';

  // 面包屑数据
  get breadcrumbNav() {
    return [
      {
        label: '通道信息',
        location: {
          name: CHANNEL_LIST
        }
      },
      {
        label: this.headTitle
      }
    ];
  }
  created() {
    console.log(this.$route.params.channelId);

    this.channelId = this.$route.params.channelId;
    this.renderDetail(this.$route.params.channelId);
  }
  async renderDetail(channelId: string) {
    try {
      const { data, status, code, msg } = await detailChannelList({ channelId });
      console.log(data);
      this.channelList = data;
    } catch (error) {
      console.log(error);
    }
  }
  channelListFormtop = [
    {
      prop: 'channelType',
      label: '通道类型 ：'
    },
    {
      prop: 'parkName',
      label: '所在车场 ：'
    },
    {
      prop: 'areaName',
      label: '所属区域 ：'
    },
    {
      prop: 'fromAreaName',
      label: '源区域 ：'
    },
    {
      prop: 'toAreaName',
      label: '目标区域 ：'
    },
    {
      prop: 'channelCode',
      label: '通道编号 ：'
    }
  ];
  channelListForm = [
    {
      prop: 'majorCameraName',
      label: '主摄像头 ：'
    },

    {
      prop: 'secondaryCameraName',
      label: '次摄像头 ：'
    },
    {
      prop: 'displayName',
      label: 'LED显示屏 ：'
    },
    {
      prop: 'roadGateName',
      label: '道闸 ：'
    },
    {
      prop: 'typeDesc',
      label: '预留设备 ：'
    }
  ];
  channelListFormbottom = [
    {
      prop: 'payUrl',
      label: '通道支付码链接地址 ：',
      render: function(h: any, params: { data: { channelType: any } }) {
        const { channelType } = params.data;
        return '';
        // return (
        //   h('span', {
        //   },[
        //     m
        //   ])
        // )
      }
    },
    {
      prop: 'noPlateEnterUrl',
      label: '无牌车入场码链接地址 ：'
    },
    {
      prop: 'noPlateExitUrl',
      label: '无牌车出场码链接地址 ：'
    }
  ];
  // // 返回
  // goBack() {
  //   this.$router.replace({
  //     name: CHANNEL_LIST,
  //   })
  // }
}
